
/**
 * Function to get the correct Firebase Functions URL
 * This is based off NODE_ENV
 */
export const getFunctionsURL = ():string => { 
	if (process.env.NODE_ENV === "production") {
		console.log("Detected Production!");
		console.log("For now, using Staging Config");
		return STAGING_URL;
	}

	if (process.env.IS_CI === "TRUE") {
		console.log("CI Environment detected!");
		console.log("Using Development Configuration");
		return DEVELOPMENT_URL;
	}
	console.log("Couldn't determine current environment");
    console.log("Defaulting to Development");
    return DEVELOPMENT_URL;
}

//The trailing slash is important!
const STAGING_URL = 'https://us-central1-sbf-dev-2.cloudfunctions.net/exportedApp/'
const DEVELOPMENT_URL = "https://us-central1-sbf-dev-79b77.cloudfunctions.net/exportedApp/";
const PRODUCTION_URL = ''


// WEBPACK FOOTER //
// ./src/utils/getFunctionsURL.ts